(function () {
    'use strict';
    const Constants = require('../constants/AppConstants');
    const _ = require('lodash');
    var LocaleUtils = require('./localeUtils');
    var defaultMessages = require('../i18n/messages/default');

    var loginHelper = {
        getAuthMethod: (token) => {
            // check for 1FA 2FA flag and return the which 2FA method applies.
            //return token.amr ? token.amr.indexOf(Constants.TWO_FA_TOTP) != -1 : false;
            var twoFaAuthMethod = null;
            if(token.amr)
            {
                twoFaAuthMethod = token.amr.indexOf(Constants.TWO_FA_TOTP) != -1 ? Constants.TWO_FA_TOTP
                    :  (token.amr.indexOf(Constants.TWO_FA_TOTP_APP) != -1 ? Constants.TWO_FA_TOTP_APP : (token.amr.indexOf(Constants.TWO_FA_WEB_AUTHN) != -1 ? Constants.TWO_FA_WEB_AUTHN : null))
            }
            return twoFaAuthMethod;
        },
        setAuthenticationMethod: (authMethods) => {
            var defaultAuthMethods = authMethods.filter(authMethod => authMethod.isDefault);
            let authMethodItem;

            if (defaultAuthMethods.length > 0) {
                authMethodItem= defaultAuthMethods[0];

            } else if (defaultAuthMethods.length == 0) {
                authMethodItem= authMethods[0];
            }
            return authMethodItem;
        },
        isFirstLogin: (token) => {
            return token.is_first_login ? token.is_first_login == 'true' : false;
        },
        getloginHeader(props) {
            var clientIdTranslationFromDB = props.translations[props.clientId.toLowerCase()] ||
                props.translations[props.clientId.toUpperCase()] || '';

            let loginHeader = '';
            if (props.clientId) {
                loginHeader = LocaleUtils.formatMessage(
                    props.intl,
                    defaultMessages,
                    props.clientId.toLowerCase(),
                    clientIdTranslationFromDB || props.clientId.toUpperCase() //fallback text
                );
            }
            else {
                loginHeader = props.intl.formatMessage(defaultMessages['login']);
            }

            return loginHeader;
        },
        getwelcomeToMetroDigitalText(props) {
            let loginHeader = '';
            if (props.clientId) {
                var phraseappKeyToLookFor = props.clientId.toLowerCase() + '_welcomeToMetroDigital'
                loginHeader = props.translations[phraseappKeyToLookFor] ||
                    props.intl.formatMessage(defaultMessages['welcomeToMetroDigital']);
                
            }
            else {
                loginHeader = props.intl.formatMessage(defaultMessages['welcomeToMetroDigital']);
            }

            return loginHeader;
        }
    };

    module.exports = loginHelper;

}());
